export default __webpack_public_path__ + "static/media/N-08.3d7ba6d6.png";